var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPredictive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_1836)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_822_1836",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H48V48H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_822_1836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 47.297C32.4375 47.3439 24.9375 47.2501 17.3442 47.297",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9768 43.7683C21.5626 42.094 25.0313 40.4065 28.5938 38.8127C30.1876 40.219 31.7813 41.6252 33.2813 43.0315C37.8751 41.1565 42.5626 39.2815 47.1648 37.3361M47.1648 37.3361C47.1305 37.3502 47.1648 38.0643 47.1648 37.3361ZM47.1648 37.3361C47.1563 40.594 47.1563 43.969 47.1563 47.2502C46.3126 47.2502 45.3751 47.2502 44.5267 47.2971",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9768 39.2681L28.6206 34.2908L33.3047 38.5223L47.1648 32.8359",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2862 35.1023L47.1648 32.8382L44.6218 32.0162",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9768 31.3333V47.2969H12.7778V31.3333",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7173 4.17948C27.1018 6.71711 30.0513 11.4585 30.0513 16.8887C30.0513 19.8439 29.1778 22.595 27.6749 24.8979",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4355 2.34204C14.7165 2.17282 16.02 2.17207 17.3012 2.3397",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02344 5.58179C6.91416 4.84454 7.89094 4.21266 8.92912 3.7036",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7148 28.9658C21.347 30.6036 18.4742 31.563 15.3772 31.563C7.27294 31.563 0.703125 24.9932 0.703125 16.8889C0.703125 14.3347 1.35562 11.933 2.50312 9.8413",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4447 26.8421C28.4447 28.4117 27.1723 29.6841 25.6028 29.6841C24.0331 29.6841 22.7607 28.4117 22.7607 26.8421C22.7607 25.2726 24.0331 24.0002 25.6028 24.0002C27.1723 24.0002 28.4447 25.2726 28.4447 26.8421Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3865 22.1996C11.3865 23.7691 10.1141 25.0415 8.54457 25.0415C6.97492 25.0415 5.70264 23.7691 5.70264 22.1996C5.70264 20.63 6.97492 19.3576 8.54457 19.3576C10.1141 19.3576 11.3865 20.63 11.3865 22.1996Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61927 8.13633C7.61927 9.7059 6.3469 10.9783 4.77733 10.9783C3.20768 10.9783 1.9353 9.7059 1.9353 8.13633C1.9353 6.56677 3.20768 5.2944 4.77733 5.2944C6.3469 5.2944 7.61927 6.56677 7.61927 8.13633Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7169 3.54527C22.7169 5.11483 21.4446 6.38721 19.875 6.38721C18.3053 6.38721 17.033 5.11483 17.033 3.54527C17.033 1.97571 18.3053 0.703333 19.875 0.703333C21.4446 0.703333 22.7169 1.97571 22.7169 3.54527Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.193 16.0003C22.193 17.5699 20.9206 18.8423 19.3511 18.8423C17.7814 18.8423 16.509 17.5699 16.509 16.0003C16.509 14.4308 17.7814 13.1584 19.3511 13.1584C20.9206 13.1584 22.193 14.4308 22.193 16.0003Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4531 23.0242H47.2969",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4531 26.2034H45.0938",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2812 3.62535H34.3125V24.6055H36.2812",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4062 14.1155H36.2812",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5965 4.10425C44.5832 3.09587 42.9433 3.09587 41.9302 4.10425",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2969 2.16113C45.3438 0.217321 42.1829 0.217321 40.2297 2.16113",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2969 14.1155C47.2969 16.0054 45.7648 17.5374 43.875 17.5374C41.9852 17.5374 40.4531 16.0054 40.4531 14.1155C40.4531 12.2257 41.9852 10.6936 43.875 10.6936C45.7648 10.6936 47.2969 12.2257 47.2969 14.1155Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0312 13.8728C43.936 13.8728 43.9376 12.4666 43.0312 12.4666C42.1265 12.4666 42.1249 13.8728 43.0312 13.8728Z",
    fill: "#102E7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_1836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictive);
export default __webpack_public_path__ + "static/media/Predictive.33b5237eca193b62cf41146cfaab2756.svg";
export { ForwardRef as ReactComponent };